<div class="wrapper" (click)="goBack()">
  <icon name="ph:caret-left-bold" size="20" />
  <p>{{ label() | translate }}</p>
</div>
